import { render } from "./ModalDeliverySlots.vue?vue&type=template&id=6c133314&scoped=true"
import script from "./ModalDeliverySlots.vue?vue&type=script&lang=js"
export * from "./ModalDeliverySlots.vue?vue&type=script&lang=js"

import "./ModalDeliverySlots.vue?vue&type=style&index=0&id=6c133314&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c133314"]])

export default __exports__